import { render, staticRenderFns } from "./DraggableColumnList.vue?vue&type=template&id=5e21cfda"
import script from "./DraggableColumnList.vue?vue&type=script&lang=ts"
export * from "./DraggableColumnList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports